/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
 */
export interface GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'colorGradation'?: GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'heightMillis'?: GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'widthMillis'?: GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum];


